import { cn } from "@/lib/utils";

const STATUS_COLORS = {
    delivered: "bg-sage",
    late: "bg-sand",
    not_good: "bg-orange-400",
    copy: "bg-purple-400",
    missed: "bg-terracotta",
    undelivered: "bg-slate-200",
    // legacy
    upcoming: "bg-slate-200",
};

const STATUS_LABEL = {
    delivered: "Dorëzuar",
    late: "Me Vonesë",
    not_good: "Jo mirë",
    copy: "Kopje",
    missed: "Mungon",
    undelivered: "Ska dorëzuar",
    upcoming: "Ska dorëzuar",
};

const STATUS_POINTS = {
    delivered: 0.5,
    late: 0.2,
    not_good: 0.3,
    copy: 0.1,
    missed: 0.0,
    undelivered: 0.0,
    upcoming: 0.0,
};

export const HomeworkTracker = ({ statuses, onClickDot, testIdPrefix = "hw", interactive = false }) => {
    return (
        <div className="flex flex-wrap gap-1.5">
            {statuses.map((s, i) => (
                <button
                    key={i}
                    type="button"
                    onClick={interactive ? () => onClickDot && onClickDot(i, s) : undefined}
                    title={`#${i + 1} • ${STATUS_LABEL[s]} (${STATUS_POINTS[s]} pik)`}
                    className={cn(
                        "hw-dot w-4 h-4 rounded-full border border-black/5 outline-none",
                        STATUS_COLORS[s] || STATUS_COLORS.undelivered,
                        interactive ? "cursor-pointer hover:ring-2 hover:ring-oxford/20" : "cursor-default",
                    )}
                    data-testid={`${testIdPrefix}-dot-${i}`}
                    data-status={s}
                />
            ))}
        </div>
    );
};

export const HomeworkLegend = () => (
    <div className="flex flex-wrap gap-3 text-xs text-slate-600">
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-sage" /> Dorëzuar (0.5p)</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-sand" /> Me Vonesë (0.2p)</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-orange-400" /> Jo mirë (0.3p)</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-purple-400" /> Kopje (0.1p)</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-terracotta" /> Mungon (0p)</span>
        <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full bg-slate-200 border" /> Ska dorëzuar (0p)</span>
    </div>
);

export { STATUS_LABEL, STATUS_POINTS };
